import React, { useContext } from "react";
import { generatePath, Navigate, useSearchParams } from "react-router-dom";
import track from "react-tracking";

import { Flex } from "@chakra-ui/react";

import CheckoutView from "components/Membership/CheckoutView";
import { RENEW_CHANNEL } from "config/channels";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import StripePaymentContextProvider from "contexts/StripePaymentContext/StripePaymentContext";
import { Loader } from "elements";
import useFetchOffers from "hooks/api/offers/useFetchOffers";
import { usePreferencesStore } from "stores/preferences";
import { usePageTracking } from "utils/tracking";

const goToEmailStep = (searchParams: URLSearchParams) => {
  return <Navigate to={{ pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY_PAGE), search: searchParams.toString() }} />;
};

const CheckoutPage = () => {
  usePageTracking();

  const [searchParams] = useSearchParams();
  const { user } = useContext(SessionContext);
  const { isLoading: isLoadingOffers, data } = useFetchOffers();
  const setCurrency = usePreferencesStore((state) => state.setCurrency);

  if (!user) {
    return goToEmailStep(searchParams);
  }

  if (isLoadingOffers) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Loader dataTestId="loader" />
      </Flex>
    );
  }

  if (data) {
    const offers = data.offers;
    const renewOffer = data.renewOffer;

    // NOTE: this is a temporary solution for payout membership renewals with unsupported currency
    if (renewOffer?.paymentFrequency === "single" && searchParams.get("channel") === RENEW_CHANNEL) {
      setCurrency("EUR");
    }

    return (
      <StripePaymentContextProvider>
        <CheckoutView offers={offers} renewOffer={renewOffer} />
      </StripePaymentContextProvider>
    );
  } else {
    return goToEmailStep(searchParams);
  }
};

export default track({ page_type: "Memberships.Buy.Checkout" })(CheckoutPage);
